import './ExpandCollapse.scss';

import React from 'react';

import bem from '../../../utils/bem';

type ExpandCollapseProps = {
  onExpandAll: () => void;
  onCollapseAll: () => void;
  areAllExpanded?: boolean;
};

const ExpandCollapse: React.FC<ExpandCollapseProps> = ({ onExpandAll, onCollapseAll, areAllExpanded }) => {
  const [block, element] = bem('notification-change-log-expand-collapse-wrapper');
  const handleToggle = (): void => {
    if (areAllExpanded) {
      onCollapseAll();
    } else {
      onExpandAll();
    }
  };

  return (
    <div className={block()}>
      <button className={element(areAllExpanded ? 'expand' : 'collapse')} onClick={handleToggle}>
        {areAllExpanded ? 'Collapse All' : 'Expand All'}
      </button>
    </div>
  );
};

export default ExpandCollapse;
